import '../css/footer.css';

export default function Footer() {
  return (
    <div className='flex justify-content-center footer-wrapper'>
        <div className='footer-text'><p>Copyright © 2022 Milcode. All rights reserved.</p></div>
    </div>
  )
}
